module.exports = __webpack_public_path__ + "media/app/assets/specializations/priest/shadow-300aea76a83150836bb8cbfc77650077.png";